import axios from 'axios'

class LocationService {
  constructor () {
    this.ENV = process.env.CONFIG
    this.countryIso = null // null: not started, otherwise a promise that will resolve to the 2-letter country code
    this.sanctionedCountries = [ // we offer bandwidth since we can't sell there any more
      'RU',  // russia
      'BY'   // belarus
    ]
  }

  isSanctioned () {
    return this.getCountryCode().then(iso => this.sanctionedCountries.includes(iso))
  }

  getCountryCode () {
    if (this.countryIso === null) {
      this.countryIso = this._loadCountry()
    }
    return this.countryIso
  }

  _loadCountry = () => {
    var request = axios.get(this.ENV.bearsMyIpURL)

    if (this.ENV.name === 'development') {
      const DEV_COUNTRY = 'RU'  // change to a sanctioned country to test sanction pages
      request = request.catch(e => {
        console.warn('Ignoring location request error for local dev and using Canada:', e)
        return { data: {'countryCode': DEV_COUNTRY, 'countryName': 'Canada', 'region': 'Ontario', 'city': 'Toronto (North York)', 'postalCode': 'M2K', 'latitude': 43.78, 'longitude': -79.4133} }
      })
    } else if (this.ENV.name === 'staging') {
      const STAGING_COUNTRY_MAP = {
        'NO': 'RU',  // test russia sanction page by connecting via norway on staging
        'CO': 'BY'   // test belarus sanction page via colombia
      }
      request = request.then(response => {
        if (response.data.countryCode in STAGING_COUNTRY_MAP) {
          response.data.countryCode = STAGING_COUNTRY_MAP[response.data.countryCode]
        }
        return response
      })
    }

    return request.then(
      response => response.data.countryCode,
      requestError => {
        this.countryIso = null  // clear out rejected promise so next getCountryCode will retry
        console.log('Failed to load location', requestError)
        return Promise.reject(new Error('Failed to load location'))
      })
  }
}

export { LocationService }



// WEBPACK FOOTER //
// ./src/services/location-service.js